import { ChannelAvatar, Text, VisuallyHidden } from '@buffer-mono/popcorn'

import type { ResultOf } from '~publish/graphql'

import type { FilterByChannel_Channel } from '../FilterByChannel'

import styles from './FilterByChannelItem.module.css'

import type { JSX } from 'react'

type Channel = ResultOf<typeof FilterByChannel_Channel>

type FilterByChannelItemProps = {
  locationData?: Channel['locationData']
  serverUrl?: Channel['serverUrl']
  avatar: Channel['avatar']
  name: Channel['name']
  service: Channel['service']
}

export function FilterByChannelItem(
  args: FilterByChannelItemProps,
): JSX.Element {
  const { locationData, serverUrl, avatar, name, service } = args

  return (
    <div className={styles.channel}>
      <ChannelAvatar
        size="small"
        alt=""
        src={avatar}
        name={name}
        channel={service}
        className={styles.avatar}
      />
      <Text weight="medium" className={styles.name}>
        {name}
        <VisuallyHidden>({service})</VisuallyHidden>
      </Text>
      {locationData?.location && (
        <Text color="subtle" className={styles.subtitle}>
          {locationData?.location}
        </Text>
      )}
      {serverUrl && (
        <Text color="subtle" className={styles.subtitle}>
          {serverUrl}
        </Text>
      )}
    </div>
  )
}
